import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { cn } from '../lib/cn';
import './Button.css';

export type ButtonVariant = 'primary' | 'ghost' | 'danger';
export type ButtonSize = 'sm' | 'md';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  /** Mostra spinner e desabilita o botão. */
  loading?: boolean;
  /** Ocupa 100% da largura do container. */
  block?: boolean;
  /** Ícone/elemento à esquerda do label. */
  iconStart?: ReactNode;
}

export function Button({
  variant = 'primary',
  size = 'md',
  loading = false,
  block = false,
  iconStart,
  type = 'button',
  className,
  disabled,
  children,
  ...rest
}: ButtonProps): JSX.Element {
  return (
    <button
      type={type}
      className={cn(
        'cf-btn',
        `cf-btn--${variant}`,
        `cf-btn--${size}`,
        block && 'cf-btn--block',
        className,
      )}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      {...rest}
    >
      {loading && <span className="cf-btn__spinner" aria-hidden="true" />}
      {!loading && iconStart && (
        <span className="cf-btn__icon" aria-hidden="true">
          {iconStart}
        </span>
      )}
      <span className="cf-btn__label">{children}</span>
    </button>
  );
}
